var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IRadioGroup',_vm._b({class:{ 'r-group-v-wrapper': _vm.props.vertical },attrs:{"radios":_vm.radios},on:{"change":_vm.changeHandler}},'IRadioGroup',_vm.props.radioOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }